export default function(ngModule) {
    /**
     * @ngdoc service
     * @name eventix.common.models.Ticket
     * @kind class
     * @description
     * A ticket that can be sold in the shop (not an instanciated that's one already sold)
     */
    ngModule.factory('Ticket', function(BaseClass, $q, $http, sortByPredecessor, Template, $timeout, $injector, $state, Product) {

        /**
         * Constructor function
         *
         * @constructor
         * @param {Object} attributes Initial attributes for the model
         */
        function Ticket(attributes) {
            _.assign(this, attributes);

            this.reserved_count = _.toInteger(this.reserved_count);
            this.pending_count = _.toInteger(this.pending_count);
            this.sold_count = _.toInteger(this.sold_count);

            if(this.fees){
                let percentage = Number(Math.round(_.get(this, 'fees.self.percentages', 0) + _.get(this, 'fees.other.percentages', 0) + 'e2') / 100 + 'e-2');
                let fixed = _.get(this, 'fees.self.fixed', 0) + _.get(this, 'fees.other.fixed', 0);

                this.original_price = 0;
                this.service_cost = _.toInteger(fixed);
                this.service_cost_percentage = percentage;
            }

            this.show_in_shop = !_.get(this, 'hide_without_coupon');

            this.allProductsLoaded = false;
        }

        Ticket.modelName = 'Ticket';

        BaseClass.apply(Ticket);

        Ticket.validates({
            name: {
                required: true
            },
            available_stock: {
                integer: true,
                required: true,
                withinBoundsStock: {
                    message: 'Not a valid amount (default: 0)',
                    validator: function(value, instance, field) {
                        if (_.isNil(value))
                            return false;
                        return value >= 0;
                    }
                }
            },
            available_from: {
                format: {
                    regex: {
                        regex: /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{2}:\d/,
                        message: 'must be a valid date'
                    }
                }
            },
            available_until: {
                format: {
                    regex: {
                        regex: /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{2}:\d/,
                        message: 'must be a valid date'
                    }
                }
            },
            availability_margin: {
                integer: true
            },
            percentage_service_costs_in_ticket: {
                integer: true,
                withinBoundsPercentage: {
                    message: 'Not a valid percentage',
                    validator: function(value, instance, field) {
                        if (_.isNil(value))
                            return false;
                        return value <= 100 && value >= 0;
                    }
                }
            },
            increment: {
                integer: true,
                required: true,
                withinBoundsIncrement: {
                    message: 'Not a valid amount (1-250 and less than or equal to minimum amount of tickets per order)',
                    validator: function(value, instance, field) {
                        if (_.isNil(value))
                            return false;

                        let max = 250;

                        if (!_.isNil(instance.min_orderable_amount_per_order))
                            max = instance.min_orderable_amount_per_order;

                        return value <= max && value >= 1;
                    }
                }
            },
            min_orderable_amount_per_order: {
                integer: true,
                required: true,
                withinBoundsMinOrderableAmount: {
                    message: 'Not a valid amount 1-250',
                    validator: function(value, instance, field) {
                        if (_.isNil(value))
                            return false;
                        return value <= 250 && value >= 1;
                    }
                }
            },
            max_orderable_amount_per_order: {
                integer: true,
                required: true,
                withinBoundsMaxOrderableAmount: {
                    message: 'Not a valid amount 1-250',
                    validator: function(value, instance, field) {
                        if (_.isNil(value))
                            return false;
                        return value <= 250 && value >= 1;
                    }
                }
            },
            vat_percentage: {
                numericality: true,
                requiredIf: {
                    requiredIf: function(value, instance, field) {
                        return _.isNumber(instance.min_price);
                    }
                },
                format: {
                    regex: {
                        regex: /\d{1,2}(?:[.,]\d{1,2})?/,
                        message: 'not a valid percentage'
                    }
                }
            },
            min_price: {
                numericality: true,
                required: true,
            }
        });

        Ticket.prototype.getTemplate = function() {
            return $http.get(`/ticket/${this.guid}/templates`).then(res => {
                if (res.data.length < 1)
                    return null;
                return Template.get({ guid: res.data[0].template_id });
            });
        };

        Ticket.prototype.$hasCustomTemplate = function() {
            let ticket = this;
            return $http.get(`/ticket/${this.guid}/templates`).then(res => {
                if (res.data.length < 1)
                    return false;
                let relation = res.data[0];
                return relation.owned_type === 'ticket' && relation.owned_id === ticket.guid;
            });
        };

        // TODO @deprecated
        Ticket.queryWithEvents = function(type, company) {
            let url = '/ticket/witheventguids';

            if (type) {
                url += '/' + (type || 'normal');
            }

            if (company) {
                url += '/' + (company);
            }

            return $http.get(url).then(res => {
                let Event = $injector.get('Event');
                return _.flatMap(res.data, d => {
                    let events = d.event_guids;
                    delete d.event_guids;
                    delete d.products;
                    return _.map(events, guid => {
                        let event = Event.cached[guid];
                        d.event = event;
                        return Ticket.new(d);
                    });
                });
            });
        };

        /**
         * @ngdoc method
         * @name eventix.common.models.Ticket#getCashrData
         * @methodOf eventix.common.models.Ticket
         * @description
         * Fetches Cashr information for ticket and converts price (if available) to cents
         * @returns {Promise<Object>} Cashr information object
         */
        Ticket.prototype.getCashrData = function() {
            if(!this.available_in_cashr)
                return $q.reject();

            return $http.get(`/ticket/${this.guid}/cashr`).then(res => {
                let data = res.data;
                data.Price = (data.Price || 0) * 100;
                return data;
            });
        };

        /**
         * @ngdoc method
         * @name eventix.common.models.Ticket#deleteFromCashr
         * @methodOf eventix.common.models.Ticket
         * @description
         * Delete ticket from Cashr
         * @returns {Promise<void>} Void
         */
        Ticket.prototype.deleteFromCashr = function() {
            if(!this.available_in_cashr)
                return $q.reject();
            return $http.delete(`/ticket/${this.guid}/cashr`);
        };

        /**
         * @ngdoc method
         * @name eventix.common.models.Ticket#saveToCashr
         * @methodOf eventix.common.models.Ticket
         * @description
         * Save/Add a ticket to Cashr
         * @param {Object} params The Cashr configuration object (SearchName, Description, Price)
         * @returns {Promise<void>} Void
         */
        Ticket.prototype.saveToCashr = function(params) {
            params.Price = params.Price > 0 ? params.Price / 100 : params.Price;
            if(!!this.available_in_cashr) {
                return $http.put(`/ticket/${this.guid}/cashr`, params).catch(err => {
                    params.Price = params.Price > 0 ? params.Price * 100 : params.Price;
                    throw err;
                });
            }
            return $http.post(`/ticket/${this.guid}/cashr`, params).catch(err => {
                params.Price = params.Price > 0 ? params.Price * 100 : params.Price;
                throw err;
            });
        };

        /**
         * @ngdoc method
         * @name eventix.common.models.Ticket#$queryMetaData
         * @methodOf eventix.common.models.Ticket
         * @description
         * Get the metaData of this tickets minimum product set
         * @param {Boolean} [cacheOnly=true] Whether to allow function to hit server or rely on cache
         * @returns {Promise} Resolves with an array of Products
         */
        Ticket.prototype.$queryMetaData = function(cacheOnly = false) {
            return this.getMinimumProductSet(cacheOnly).then(products => {
                return $q.all(_.map(products, p => p.$queryMetaData(cacheOnly)));
            }).then(metaData => {
                return _.uniqBy(_.flatten(metaData), 'guid');
            });
        };

        Ticket.prototype.fillProducts = function(cacheOnly = false, force = false) {
            if(this.allProductsLoaded && !force){
                return $q.resolve();
            }
            this.allTicketProductGuids = [];
            this.groupProductGuids = [];
            this.nonGroupProducts = [];
            this.forcedProductGuids = [];

            return this.$queryProduct(cacheOnly).then(products => {
                this.allTicketProductGuids = _.map(products, 'guid');
                return this.$queryProductGroup(cacheOnly)
            }).then(groups => {
                _.forEach(groups, g => {
                    this.groupProductGuids = _.uniq(_.concat(this.groupProductGuids, g.members))
                });
                let promises = _.map(groups, g => {
                    return g.getRequiredProductSet()
                        .catch(err => {
                            if(err && err.message === 'NonRequiredGroup')
                                return $q.resolve([]);
                            return $q.reject(err);
                        });
                });
                return $q.all(promises);
            }).then(requiredGroupProducts => {
                _.forEach(requiredGroupProducts, products => {
                    this.forcedProductGuids = _.uniq(_.concat(this.forcedProductGuids, _.map(products, 'guid')));
                });
                this.nonGroupProducts = _.difference(this.allTicketProductGuids, this.groupProductGuids);
                this.forcedProductGuids = _.uniq(_.concat(this.forcedProductGuids, this.nonGroupProducts));
                this.allProductsLoaded = true;
                return $q.resolve();
            });
        }

        /**
         * @ngdoc method
         * @name eventix.common.models.Ticket#getMinimumProductSet
         * @methodOf eventix.common.models.Ticket
         * @description
         * Get minimum set of products that validates all product group bounds
         * @param {Boolean} [cacheOnly=true] Whether to allow function to hit server or rely on cache
         * @returns {Promise} Resolves with an array of Products
         */
        Ticket.prototype.getMinimumProductSet = function(cacheOnly = true) {
            return this.fillProducts(cacheOnly).then(res => {
                return this.$queryProductGroup(cacheOnly)
            }).then(groups => {
                    let promises = _.map(groups, g => g.getMinimumProductSet(cacheOnly));
                    _.map(this.forcedProductGuids, guid => {
                        promises.push(Product.get({ guid: guid }));
                    });
                    return $q.all(promises);
                }).then(groupProducts => {
                    let products = _.uniqBy(_.flatten(groupProducts), 'guid');
                    return products;
                });
        };

        /**
         * @ngdoc method
         * @name eventix.common.models.Ticket#getRequiredProductSet
         * @methodOf eventix.common.models.Ticket
         * @description
         * Get the set of products that a ticket can never be valid without. i.e.: in ProductGroups with
         * exact or min choose with bound equal to members.length
         * @param {Boolean} [cacheOnly=true] Whether to allow function to hit server or rely on cache
         * @returns {Promise} Resolves with an array of Products
         */
        Ticket.prototype.getRequiredProductSet = function(cacheOnly = true) {
            return this.fillProducts(cacheOnly).then(res => {
                let promises = [];
                _.map(this.forcedProductGuids, guid => {
                    promises.push(Product.get({ guid: guid }));
                });
                return $q.all(promises);
            }).then(products => {
                return products;
            });
        };

        /**
         * @ngdoc method
         * @name eventix.common.models.Ticket#calculateMinimumPrice
         * @methodOf eventix.common.models.Ticket
         * @description
         * Calculate the minimum price of this ticket across ProductGroups.
         * This calculation is not reliable by its very nature because we don't
         * know which products are still available for reservation.
         *
         * Caches the result under `this.minimumPrice`.
         *
         * See ProductGroup#calculateMinimumPrice as well
         * @param {Boolean} [cacheOnly=true] Whether to allow function to hit server or rely on cache
         * @returns {Promise} Resolves with a minumum price
         */
        Ticket.prototype.calculateMinimumPrice = function(cacheOnly = true) {
            return this.getMinimumProductSet(cacheOnly).then(products => {
                if(this.min_price === null) {
                    this.minimumPrice = this.original_price = _.reduce(products, (t, p) => t + _.toInteger(p.ticketPrice), 0);
                    if(this.minimumPrice > 0 && _.get(this, 'include_service_cost_in_price', false)){
                        let varying = (this.original_price) * this.service_cost_percentage;
                        this.minimumPrice += this.service_cost + varying;
                    }
                    return this.minimumPrice;
                }
                else{
                    this.original_price = this.minimumPrice = this.min_price;
                    if(this.minimumPrice > 0 && _.get(this, 'include_service_cost_in_price', false)){
                        let varying = (this.original_price) * this.service_cost_percentage;
                        this.minimumPrice += this.service_cost + varying;
                    }
                    return this.minimumPrice;
                }
            });
        };

        /**
         * @ngdoc method
         * @name eventix.common.models.Ticket#calculateDiscountPrice
         * @methodOf eventix.common.models.Ticket
         * @description
         * Calculate the discounted price of this ticket across ProductGroups.
         * This calculation is not reliable by its very nature because we don't
         * know which products are still available for reservation.
         *
         * Caches the result under `this.discountPrice`.
         * @param {ShopCoupon} coupon A shopCoupon to apply
         * @param {Boolean} [cacheOnly=true] Whether to allow function to hit server or rely on cache
         * @returns {Promise} Resolves with a minumum price
         */
        Ticket.prototype.calculateDiscountPrice = function(coupon, cacheOnly = true) {
            let products;
            let discounts;
            return this.getMinimumProductSet(cacheOnly).then(_products => {
                products = _products;
                discounts = coupon.calculateDiscountsForProductSet(products);
                if(this.min_price === null) {
                    let totalDiscount = _.sum(_.values(discounts));
                    let totalPrice = _.sumBy(products, 'ticketPrice');
                    this.discountPrice = this.orignal_discount_price = totalPrice - totalDiscount;
                    if(this.discountPrice > 0 && _.get(this, 'include_service_cost_in_price', false)){
                        let varying = this.orignal_discount_price * this.service_cost_percentage;
                        this.discountPrice += this.service_cost + varying;
                    }
                    return this.discountPrice;
                }
                return this.getRequiredProductSet(cacheOnly)
                    .then(requiredProducts => {
                        let total = _.reduce(products, (total, product) => {
                            let isRequired = _.findIndex(requiredProducts, { guid: product.guid }) >= 0;
                            if(isRequired)
                                return total - discounts[product.guid];
                            return total + (product.ticketPrice - discounts[product.guid]);
                        }, this.min_price);
                        this.discountPrice = this.orignal_discount_price = total;
                        if(this.discountPrice > 0 && _.get(this, 'include_service_cost_in_price', false)){
                            let varying = this.orignal_discount_price * this.service_cost_percentage;
                            this.discountPrice += this.service_cost + varying;
                        }
                        return this.discountPrice;
                    });
            });
        };

        /**
         * Check ticket availibility and future dates
         *
         * Caches the result on `ticket.available` but also sets the booleas flags
         * `ticket.comingSoon` and `ticket.recentlyExpired` and `ticket.hasFuture`
         *
         * @param {Boolean} [cacheOnly=true] Whether to utilize cache

         * If false is given, an asynchronous action may change availability -
         * specifically because of `hasFuture` - within another digest cycle.
         * @returns {Boolean} True if ticket is available
         */
        Ticket.prototype.isAvailable = function(cacheOnly = true) {
            let timeWindow = _.get(this, 'availability_margin', 15);
            let from = moment(this.available_from, 'YYYY-MM-DDTHH:mm:ssZ');
            let until = moment(this.available_until, 'YYYY-MM-DDTHH:mm:ssZ');
            let now = moment();
            let fromDiff = from.diff(now, 'seconds');   // Positive integer if availableFrom  lies in the future
            let untilDiff = until.diff(now, 'seconds'); // Positive integer if availableUntil lies in the future
            let fromBoundaryOK = !from.isValid() || fromDiff < 2;    // availableFrom  is invalid (always okay) or it equals now with a 1s margin of error
            let untilBoundaryOK = !until.isValid() || untilDiff > 0; // availableUntil is invalid (always okay) or it equals now
            this.comingSoon = fromDiff > 1 && // availableFrom is in the future but is less than 15 minutes away
                (fromDiff / 60 < timeWindow || timeWindow === 0);
            this.recentlyExpired = untilDiff < 1 && // availableUntil has passed but is less than 15 minutes ago
                (-untilDiff / 60 < timeWindow || timeWindow === 0);

            // Check if all dates lie in the past
            now = now.format('YYYY-MM-DDTHH:mm:ssZ');
            if(cacheOnly) {
                let products = this.belongsToMany.restore('Product');
                let dates = _.flatMap(products, p => p.belongsToMany.restore('EventDate'));
                this.hasFuture = _.find(dates, date => date.end > now) !== undefined;
            } else {
                return this.$queryProduct().then(products => {
                    let promises = _.map(products, p => p.$queryEventDate());
                    return $q.all(promises);
                }).then(dates => {
                    dates = _.flatten(dates);
                    this.hasFuture = _.find(dates, date => date.end > now) !== undefined;
                    this.available = (fromBoundaryOK || this.comingSoon) &&
                                     (untilBoundaryOK || this.recentlyExpired) &&
                                     this.hasFuture;
                    if(this.available && this.status === 'not_sold_right_now')
                        this.status = 'available';
                    return this.available;
                });
            }

            // ticket.available indicates whether it should display ticket in shop (so its within availability+margins)
            this.available = (fromBoundaryOK || this.comingSoon) && (untilBoundaryOK || this.recentlyExpired) && this.hasFuture;
            if(this.available && this.status === 'not_sold_right_now')
                this.status = 'available';
            return this.available;
        };

        Ticket.configureAPIMessages({
            'POST /shop/:shop_guid/tickets': {
                406: 'models.shop.notice.ticketAlreadyAssigned'
            },
            'DELETE /shop/:shop_guid/tickets': {
                406: 'models.shop.notice.ticketNotAssigned'
            }
        });

        Ticket.configureApi('/ticket/:guid', { queryAdmin: '/ticket/:status/:company', reinstate: '/ticket/:guid/reinstate' });
        Ticket.prototype.toString = function() { return this.name; };
        Ticket.belongsToMany('Shop', 'shops', '/shop/^guid/tickets/:guid', [
            { type: 'attach' },
            { type: 'detach' },
            { type: 'query', url: '/ticket/:guid/shops' }
        ]);
        Ticket.belongsToMany('ProductGroup', 'groups', '/ticket/:guid/groups/^guid', [
            {
                type: 'attach',
                fn: function(modelName, url, ticket, group, cacheOnly) {
                    group.ticket_id = ticket.guid;
                    return group.$save();
                }
            },
            { type: 'query', url: '/ticket/:guid/groups/products', success: groups => sortByPredecessor(groups) },
            { type: 'reorder', url: '/ticket/:guid/groups/reorder' }
        ]);
        Ticket.belongsToMany('Product', 'products', '/ticket/:guid/products/^guid', [
            { type: 'attach' },
            { type: 'detach' },
            { type: 'update' },
            { type: 'query', success: products => sortByPredecessor(products) },
            { type: 'reorder', url: '/ticket/:guid/products/reorder' }
        ]);
        Ticket.belongsToMany('EventDate', 'eventDates', '/ticket/:guid/dates/^guid', [
            { type: 'attach' },
            { type: 'detach' },
            { type: 'query' }
        ]);
        // Because a trigger product will exists for each ticket, this magically works..
        Ticket.belongsToMany('MetaData','meta_data','/product/:guid/metaData/^guid',[
            {
                type: 'query',
                success: meta => sortByPredecessor(meta)
            },
            { type: 'attach' },
            { type: 'detach' },
            { type: 'reorder', url: '/product/:guid/metaData/reorder' }
        ]);

        Ticket.belongsToMany('OptionalProduct', 'optionalProducts', '/ticket/:guid/products/^guid', [
            {
                type: 'attach',
                fn: function(modelName, url, ticket, product, pivot) {
                    return ticket.$attachProduct(product, pivot);
                }
            }, {
                type: 'detach',
                fn: function(modelName, url, ticket, product, pivot) {
                    return ticket.$detachProduct(product, pivot);
                }
            }, {
                type: 'query',
                fn: function(modelName, url, ticket, cacheOnly) {
                    if(ticket.belongsToMany[modelName] || cacheOnly)
                        return $q.resolve(ticket.belongsToMany.restore(modelName));
                    var Product = $injector.get('Product');
                    var products;

                    return ticket.$queryProduct().then(_products => {
                        products = _products;
                        return ticket.$queryProductGroup();
                    }).then(groups => {
                        // Filter out semi-required products
                        products = _.filter(products, product => {
                            return _.find(groups, group => {
                                return _.indexOf(group.products, product.guid) >= 0;
                            }) === undefined;
                        });
                        return $q.all(products);
                    }).catch(error => {
                        ticket.broadcastAPIMessage(error);
                        return $q.reject(error);
                    });
                }
            }
        ]);
        Ticket.belongsToMany('RequiredProduct', 'requiredProducts', '/ticket/:guid/products/^guid', [
            {
                type: 'attach',
                fn: function(modelName, url, ticket, product, pivot) {
                    return ticket.$attachProduct(product, pivot);
                }
            }, {
                type: 'detach',
                fn: function(modelName, url, ticket, product, pivot) {
                    return ticket.$detachProduct(product, pivot);
                }
            }, {
                type: 'query',
                fn: function(modelName, url, ticket, cacheOnly) {
                    if(ticket.belongsToMany[modelName] || cacheOnly)
                        return $q.resolve(ticket.belongsToMany.restore(modelName));
                    var Product = $injector.get('Product');

                    return ticket.$queryProductGroup().then(groups => {
                        // Filter out groups that don't require all their products
                        let promises = _.map(groups, group => group.getRequiredProductSet().catch(error => {
                            if(error.message === 'NonRequiredGroup')
                                return [];
                            return $q.reject(error);
                        }));
                        return $q.all(promises);
                    }).then(productSets => {
                        // Query required products for eventDate
                        let products = _.map(_.flatten(productSets), product => {
                            ticket.belongsToMany.cache('RequiredProduct', product);
                            return product;
                        });
                        return _.compact(products);
                    }).catch(error => {
                        ticket.broadcastAPIMessage(error);
                        return $q.reject(error);
                    });
                }
            }
        ]);
        Ticket.belongsToMany('AddonProduct', 'addonProducts', '/ticket/:guid/products/^guid', [
            {
                type: 'attach',
                fn: function(modelName, url, ticket, product, pivot) {
                    return ticket.$attachProduct(product, pivot);
                }
            }, {
                type: 'detach',
                fn: function(modelName, url, ticket, product, pivot) {
                    return ticket.$detachProduct(product, pivot);
                }
            }, {
                type: 'query',
                fn: function(modelName, url, ticket, cacheOnly) {
                    if(ticket.belongsToMany[modelName] || cacheOnly)
                        return $q.resolve(ticket.belongsToMany.restore(modelName));
                    var Product = $injector.get('Product');
                    var products;

                    return ticket.$queryProduct().then(_products => {
                        products = _products;
                        return ticket.$queryProductGroup();
                    }).then(groups => {
                        // Filter out groups that don't require all their products
                        let promises = _.map(groups, group => group.getRequiredProductSet().catch(error => {
                            if(error.message === 'NonRequiredGroup')
                                return [];
                            return $q.reject(error);
                        }));
                        return $q.all(promises);
                    }).then(productSets => {
                        // Query required products for eventDate
                        let promises = _.map(_.flatten(productSets), product => {
                            return product.$queryEventDate()
                                .then(dates => {
                                    if(dates && dates.length)
                                        return null;
                                    // Init AccessProduct
                                    ticket.belongsToMany.cache('AddonProduct', product);
                                    return product;
                                });
                        });
                        return $q.all(promises);
                    }).then(function(addonProducts) {
                        return _.compact(addonProducts);
                    }).catch(error => {
                        ticket.broadcastAPIMessage(error);
                        return $q.reject(error);
                    });
                }
            }
        ]);
        Ticket.belongsToMany('AccessProduct', 'accessProducts', '/ticket/:guid/products/^guid', [
            {
                type: 'attach',
                fn: function(modelName, url, ticket, product, pivot) {
                    return ticket.$attachProduct(product.product, pivot);
                }
            }, {
                type: 'detach',
                fn: function(modelName, url, ticket, product, pivot) {
                    return ticket.$detachProduct(product.product, pivot);
                }
            }, {
                type: 'query',
                fn: function(modelName, url, ticket, cacheOnly) {
                    if(ticket.belongsToMany[modelName] || cacheOnly)
                        return $q.resolve(ticket.belongsToMany.restore(modelName));
                    var Product = $injector.get('Product');
                    var AccessProduct = $injector.get('AccessProduct');
                    var products;

                    return ticket.$queryProduct().then(_products => {
                        products = _products;
                        return ticket.$queryProductGroup();
                    }).then(groups => {
                        // Filter out groups that don't require all their products
                        let promises = _.map(groups, group => group.getRequiredProductSet().catch(error => {
                            if(error.message === 'NonRequiredGroup')
                                return [];
                            return $q.reject(error);
                        }));
                        return $q.all(promises);
                    }).then(productSets => {
                        // Query required products for eventDate
                        let promises = _.map(_.flatten(productSets), product => {
                            return product.$queryEventDate()
                                .then(dates => {
                                    if(!dates || !dates.length)
                                        return null;
                                    // Init AccessProduct
                                    let aProduct = new AccessProduct({
                                        product: product,
                                        eventDate: dates[0]
                                    });
                                    ticket.belongsToMany.cache('AccessProduct', aProduct);
                                    return aProduct;
                                });
                        });
                        return $q.all(promises);
                    }).then(function(accessProducts) {
                        return _.compact(accessProducts);
                    }).catch(error => {
                        ticket.broadcastAPIMessage(error);
                        return $q.reject(error);
                    });
                }
            }
        ]);

        return Ticket;
    });
}
